import { render, staticRenderFns } from "./documentBlock.vue?vue&type=template&id=254198b0&scoped=true"
import script from "./documentBlock.vue?vue&type=script&lang=js"
export * from "./documentBlock.vue?vue&type=script&lang=js"
import style0 from "./documentBlock.vue?vue&type=style&index=0&id=254198b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254198b0",
  null
  
)

export default component.exports